// #region Imports
import { defineComponent, h, resolveComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    name: 'g-dynamic',
    props: {
        metadata: {
            type: Object,
            required: true,
        },
        dataobject: {
            type: Object,
            required: true,
        }
    },
    render() {
        const getChildren = (Components) => {
            const children = [];
            if (Components === undefined) {
                return children;
            }
            if (Components.length === 0) {
                return children;
            }
            Components.forEach((e) => {
                children.push(h(resolveComponent("g-dynamic"), { metadata: e, dataobject: this.dataobject }, {
                    default() {
                        return getChildren(e.components);
                    }
                }));
            });
            return children;
        };
        //Attributes
        let tData = this.metadata.attributes;
        let tMetadata = this.metadata;
        //Set
        if (!utils.isEmpty(this.metadata.dataMember)) {
            tData = Object.assign(this.metadata.attributes, { modelValue: this.dataobject[this.metadata.dataMember], 'onUpdate:modelValue': (value) => this.dataobject[this.metadata.dataMember] = value });
        }
        tData = Object.assign(tData, { metadata: this.metadata, dataobject: this.dataobject });
        return h(resolveComponent(this.metadata.component), tData, {
            default() {
                return getChildren(tMetadata.components);
            }
        });
    },
});
// #endregion
